import React from 'react';

import Context from '../../../../../../context';

import { useTranslation    } from 'react-i18next';
import { locationNamespace } from '../../../../../../types/location.namespace';
import { CustomDropdownFilter, CustomButton2, LocationDropdowns } from '../../../../../../components';

import './index.sass';
import utils from "../../../../../../utils";
import Cookies from "js-cookie";
import values from "../../../../../../values";

const Filter: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const { t } = useTranslation();
  const userType = utils.stringHexConversion.reverse(Cookies.get(values.constants.USER.TYPE));
  const { setRequestNeighborhood, requestNeighborhood } = React.useContext(Context.Location.Neighborhood);
  const [ selectedArea, setSelectedArea ] = React.useState<locationNamespace.area.index | undefined>(undefined);
  const [ selectedCity, setSelectedCity ] = React.useState<locationNamespace.city.index | undefined>(undefined);
  const [ selectedProvince, setSelectedProvince ] = React.useState<locationNamespace.province.index | undefined>(undefined);

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  function onSelectProvince(province: locationNamespace.province.index | undefined): void {
    setSelectedProvince(province);
    if (!province) return setRequestNeighborhood!({
      ...requestNeighborhood,
      province: undefined,
      page: 1,
    });
    setRequestNeighborhood!({
      ...requestNeighborhood,
      province: province._id,
      page: 1,
    });
  }

  function onSelectCity(city: locationNamespace.city.index | undefined): void {
    setSelectedCity(city);
    if (!city) return setRequestNeighborhood!({
      ...requestNeighborhood,
      city: undefined,
      page: 1,
    });
    setRequestNeighborhood!({
      ...requestNeighborhood,
      city: city._id,
      page: 1,
    });
  }

  function onSelectArea(area: locationNamespace.area.index | undefined): void {
    setSelectedArea(area);
    if (!area) return setRequestNeighborhood!({
      ...requestNeighborhood,
      town: undefined,
      page: 1,
    });
    setRequestNeighborhood!({
      ...requestNeighborhood,
      town: area._id,
      page: 1,
    });
  }

  function handleOnClickReFetch(): void {
    setSelectedProvince(undefined);
    setSelectedCity(undefined);
    setRequestNeighborhood!({ page: 1, limit: 10 });
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <div className='filter-container'>
      <CustomDropdownFilter title={t('filter')} hoverTitle={t('filter')}>
        {userType === 'ADMIN' && (
          <>
            <LocationDropdowns.Province defaultItem={selectedProvince} onSelectItem={onSelectProvince} />
            <LocationDropdowns.City
              defaultItem     = { selectedCity     }
              onSelectItem    = { onSelectCity     }
              selectedProvince= { selectedProvince }
            />
          </>
        )}
        <LocationDropdowns.Area
          defaultItem     = { selectedArea     }
          onSelectItem    = { onSelectArea     }
          selectedCity    = { selectedCity     }
          selectedProvince= { selectedProvince }
        />
        <div className='filter-footer'>
          <CustomButton2 onClick={handleOnClickReFetch} title={t('reset')} type='primary'/>
        </div>
      </CustomDropdownFilter>
    </div>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default Filter;
